import zappy from "@zappy-ride/library.react.components";
import { OutputTemplate } from "./OutputTemplate";

export * from "./OutputTemplate";

zappy.FactoryInstance.registerComponent(OutputTemplate);
